module.exports = __webpack_public_path__ + "media/components/alert-table/static/icon-checkbox-01e11804f0a878b15142018488046980.svg";